const {
	fillWithDomElements,
	fillWithDomElementsAll,
	awaitControllersReady,
	twoCiphers,
	awaitNextFrame,
	trackGtm,
	trackGtm4,
} = require('util/functions');
const asyncImport = require('util/asyncImport').default;

const CLASS_SEARCH_BUTTON = 'news-and-press-releases--search-button';
const CLASS_SEARCH = 'news-and-press-releases--input-search';
const CLASS_FORM = 'news-and-press-releases--form';
const CLASS_FORM_CONTAINER = 'news-and-press-releases--form-container';
const CLASS_FROM = 'news-and-press-releases--input-from';
const CLASS_CALENDAR_FROM = 'news-and-press-releases--calendar-from';
const CLASS_TO = 'news-and-press-releases--input-to';
const CLASS_CALENDAR_TO = 'news-and-press-releases--calendar-to';
const CLASS_LIST = 'news-and-press-releases--list';
const CLASS_NAV = 'pages-nav';
const CLASS_SUBMIT = 'news-and-press-releases--submit';
const CLASS_CLEAR = 'news-and-press-releases--clear-button';
const CLASS_ARTICLE_COUUNT = 'news-and-press-releases--article-count';
const CLASS_DOWNLOAD = 'download';
const CLASS_LOADING_OVERLAY = 'loading-overlay';

const CLASS_ACTIVE = 'active';
const CLASS_ARROW_DOWN = 'arrow-down';

const renderList = require('../news-releases-article/template.hbs');

const selectors = {
	loadingOverlay: CLASS_LOADING_OVERLAY,
	formContainer: CLASS_FORM_CONTAINER,
	articleCount: CLASS_ARTICLE_COUUNT,
	list: CLASS_LIST,
	search: CLASS_SEARCH,
	button: CLASS_SEARCH_BUTTON,
	form: CLASS_FORM,
	fromField: CLASS_FROM,
	calendarFrom: CLASS_CALENDAR_FROM,
	toField: CLASS_TO,
	calendarTo: CLASS_CALENDAR_TO,
	navElement: CLASS_NAV,
	submit: CLASS_SUBMIT,
	clear: CLASS_CLEAR,
};

const selectorAll = {
	download: CLASS_DOWNLOAD,
};
module.exports = {
	async init() {
		fillWithDomElements(this, selectors);
		fillWithDomElementsAll(this, selectorAll);
		await awaitControllersReady([this.navElement]);
		this.navController = this.navElement.__controller;
		this.apiUrl = this.root.dataset.api;
		if (!!this.root.dataset.press) {
			this.pagesCount = this.root.dataset.pressPagesCount;
			this.press = true;
		} else {
			this.pagesCount = this.root.dataset.newsPagesCount;
			this.press = false;
		}

		this.initCalendars();
		this.initPagination();

		this.numbers =
			this.navController.root.querySelectorAll('.pages-nav--number');
		this.firstButton =
			this.navController.root.querySelector('.pages-nav--first');
		this.lastButton = this.navController.root.querySelector('.pages-nav--last');

		this.initEvents();
	},
	initEvents() {
		const title = this.root.parentNode.parentNode.querySelector(
			'.news-and-press-releases--title',
		);

		[
			[this.button, this.toggleSearch],
			[this.submit, this.updateSearch],
			[this.clear, this.resetForm],
		].forEach(([element, callback]) =>
			element.addEventListener('click', callback.bind(this)),
		);
		this.download.forEach(download => {
			download.addEventListener('click', ({ target }) => {
				this.gtmTracking(target.parentElement.parentElement);
			});
		});
		[this.search, this.fromField, this.toField].forEach(element => {
			element.addEventListener('keyup', this.onUpdate.bind(this));
		});
		this.firstButton.addEventListener('click', e => {
			trackGtm4({
				event: 'GA4_event_c_content_navigation_click',
				widget_name: 'V3-Press-release-and-news-search',
				widget_title: title ? title.textContent.trim() : 'Title not set',
				widget_type: 'search',
				link_text: e.target.textContent.trim(),
				link_url: 'No url',
				interaction_type: e.target.textContent.trim().toLowerCase(),
			});
		});
		this.lastButton.addEventListener('click', e => {
			trackGtm4({
				event: 'GA4_event_c_content_navigation_click',
				widget_name: 'V3-Press-release-and-news-search',
				widget_title: title ? title.textContent.trim() : 'Title not set',
				widget_type: 'search',
				link_text: e.target.textContent.trim(),
				link_url: 'No url',
				interaction_type: e.target.textContent.trim().toLowerCase(),
			});
		});
	},
	gtmTracking(element) {
		const title = element.querySelector(
			'.news-and-press-item--title',
		).textContent;
		const link = element.querySelector('.news-and-press-item--top-link').href;
		trackGtm({
			event: 'GA Tracking',
			eventCategory: 'outgoing tracking',
			eventAction: 'download',
			eventLabel: `${title} / ${link}`,
		});
	},
	resetForm() {
		this.form.reset();
		this.onUpdate();
		this.updateResults(0);
	},
	initPagination() {
		this.navController.init();
		this.setPagination(0, Number(this.pagesCount));
	},
	changePage(number) {
		const title = this.root.parentNode.parentNode.querySelector(
			'.news-and-press-releases--title',
		);
		this.navController.setActivePage(number);
		this.updateResults(number);

		this.root.addEventListener('click', event => {
			event.stopImmediatePropagation();
			const hasAriaLabel = event.target.hasAttribute('aria-label');
			if (
				!hasAriaLabel &&
				event.target.classList.contains('pages-nav--number')
			) {
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: 'V3-Press-release-and-news-search',
					widget_title: title ? title.textContent.trim() : 'No title',
					widget_type: 'search',
					link_text: event.target.innerHTML.trim(),
					link_url: 'No url',
					interaction_type: `page ${event.target.innerHTML.trim()}`,
				});
			}

			setTimeout(() => {
				const itemCount = this.root.querySelector(
					'.news-and-press-releases--article-count',
				);
				trackGtm4({
					event: 'GA4_event_c_search_result',
					search_term:
						this.search.value.length > 0 ? this.search.value : 'none',
					number: itemCount.innerHTML.trim().split(' ')[0],
					search_filter: `${
						this.fromField.value || this.root.dataset.fromLabel
					}|${this.toField.value || this.root.dataset.toLabel}`,
					widget_name: 'V3-Press-release-and-news-search',
				});
			}, 1000);
		});
	},
	async updateResults(page) {
		this.loadingOverlay.classList.add(CLASS_ACTIVE);
		await awaitNextFrame();
		const { items, pageCount, totalFound } = await this.fetch(page);
		const foundLabel = this.press
			? this.root.dataset.pressFoundLabel
			: this.root.dataset.newsFoundLabel;

		this.setPagination(page, pageCount);
		this.articleCount.textContent = totalFound + ' ' + foundLabel;
		this.list.innerHTML = items
			.map(data =>
				renderList({
					...data,
				}),
			)
			.join('');
		this.loadingOverlay.classList.remove(CLASS_ACTIVE);
	},
	async updateSearch(e) {
		e.preventDefault();

		this.submit.classList.remove(CLASS_ACTIVE);
		this.updateResults(0);

		trackGtm4({
			event: 'GA4_event_c_search',
			search_term: this.search.value.length > 0 ? this.search.value : 'none',
			search_location: 'page',
			search_filter: `${this.fromField.value || this.root.dataset.fromLabel}|${
				this.toField.value || this.root.dataset.toLabel
			}`,
			widget_name: 'V3-Press-release-and-news-search',
		});
	},
	setPagination(current, total) {
		this.navController.setDynamicPagination(
			current,
			total - 1,
			this.changePage.bind(this),
		);
	},
	async onUpdate(e) {
		if (e?.keyCode !== 13) {
			// necessary or else the value of the elements won't be updated
			// and isBlank check wont be accurate
			await awaitNextFrame();
			const fields = [this.search, this.fromField, this.toField];
			const isBlank = !fields.some(el => el.value);
			const hasChanged = fields.some(
				el => el.value !== (el.__initialValue || ''),
			);
			this.submit.classList.toggle(CLASS_ACTIVE, hasChanged && !isBlank);
		}
	},
	getUrl(page) {
		const search = this.search.value;
		const fromField = this.fromField.value;
		const toField = this.toField.value;
		const category = this.press ? 2 : 1;
		const {
			newsTitle,
			pressTitle,
			selectedPressId,
			pressDetailId,
			pressExternalId,
			selectedNewsId,
			newsDetailId,
			rowsToShow,
		} = this.root.dataset;
		return `${this.apiUrl}?${[
			['page', page],
			['search', search],
			['from', fromField],
			['to', toField],
			['category', category],
			['newsTitle', newsTitle],
			['pressReleasesTitle', pressTitle],
			['selectedPressReleasesCategoryId', selectedPressId],
			['pressReleasesDetailPageId', pressDetailId],
			['pressReleasesExternalDetailPageId', pressExternalId],
			['selectedNewsCategoryId', selectedNewsId],
			['newsItemDetailPageId', newsDetailId],
			['rowsToShow', rowsToShow],
		]
			.map(([param, value]) => `&${param}=${value}`)
			.join('')}		`;
	},
	async fetch(page) {
		const url = this.getUrl(page);
		const response = await fetch(url).catch(error => console.error(error));
		if (!response.ok)
			throw new Error('News and press releases api resonse error');

		return await response.json();
	},
	toggleSearch() {
		this.form.reset();
		this.onUpdate();
		this.formContainer.classList.toggle(CLASS_ACTIVE);
		this.clear.classList.toggle(CLASS_ACTIVE);
		this.button.classList.toggle(CLASS_ARROW_DOWN);
		const isShown = this.formContainer.classList.contains(CLASS_ACTIVE);

		trackGtm4({
			event: 'GA4_event_c_content_interaction',
			widget_name: 'V3-Press-release-and-news-search',
			widget_title: this.root.dataset.parentTitle,
			link_text: this.button.innerHTML.trim(),
			interaction_type: isShown ? 'show more' : 'show less',
		});
	},
	async initCalendars() {
		await asyncImport(this, 'pikaday');

		this.fromPicker = new this.pikaday(
			this.getCalendarOptions(this.fromField, this.calendarFrom),
		);
		this.toPicker = new this.pikaday(
			this.getCalendarOptions(this.toField, this.calendarTo),
		);
	},
	getCalendarOptions(field, container) {
		let { months, weekdays, previousMonth, nextMonth } = this.root.dataset;
		[months, weekdays] = [months, weekdays].map(list => list.split(','));
		return {
			field: field,
			container: container,
			disableWeekends: true,
			minDate: undefined,
			maxDate: undefined,
			toString(date) {
				return [date.getMonth() + 1, date.getDate(), date.getFullYear()]
					.map(number => twoCiphers(number))
					.join('/');
			},
			i18n: {
				previousMonth,
				nextMonth,
				months,
				weekdays,
				weekdaysShort: weekdays,
			},
			onSelect: () => {
				this.onUpdate();
			},
			onOpen: function () {
				const { container } = this._o;
				//Solves Chrome issue where the calander closes on first click
				setTimeout(() => {
					container.classList.add(CLASS_ACTIVE);
				}, 100);
			},
			onClose: function () {
				const { container } = this._o;
				//Solves Chrome issue where the calander closes on first click
				setTimeout(() => {
					container.classList.remove(CLASS_ACTIVE);
				}, 100);
			},
		};
	},
};
